import { comonDataApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

async function deleteCommonData(interfaceId: number): Promise<void> {
  await comonDataApi.deleteStationFile(interfaceId)
}

function useDeleteStationData() {
  const queryClient = useQueryClient()

  return useMutation((payload: any) => deleteCommonData(payload.interfaceId), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.commonData])
      toast.success('Reset data successful')
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.Message)
    },
  })

  // return mutate
}

export default useDeleteStationData
